import React from "react";

export default function WhatsAppIcon({ size = 18, className = "" }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.02 3.2C8.96 3.2 3.22 8.9 3.22 15.92c0 2.4.68 4.68 1.88 6.64L3.1 29l6.62-1.94a12.8 12.8 0 0 0 6.3 1.62c7.06 0 12.8-5.7 12.8-12.76S23.08 3.2 16.02 3.2Zm0 23.32c-2.02 0-3.88-.58-5.48-1.58l-.4-.24-3.92 1.14 1.18-3.8-.26-.4a10.42 10.42 0 0 1-1.76-5.72c0-5.82 4.78-10.56 10.64-10.56 5.88 0 10.66 4.74 10.66 10.56 0 5.84-4.78 10.6-10.66 10.6Zm5.84-7.92c-.32-.16-1.9-.94-2.2-1.04-.3-.12-.52-.16-.74.16-.22.32-.84 1.04-1.04 1.26-.18.22-.38.24-.7.08-.32-.16-1.36-.5-2.58-1.58-.96-.86-1.6-1.92-1.78-2.24-.18-.32-.02-.5.14-.66.14-.14.32-.38.48-.56.16-.18.22-.32.32-.54.1-.22.06-.4-.02-.56-.08-.16-.74-1.78-1.02-2.44-.26-.64-.54-.56-.74-.56h-.62c-.22 0-.56.08-.86.4-.3.32-1.12 1.1-1.12 2.68s1.14 3.1 1.3 3.32c.16.22 2.24 3.42 5.42 4.8.76.32 1.36.52 1.82.66.76.24 1.46.2 2.02.12.62-.1 1.9-.78 2.16-1.52.26-.74.26-1.38.18-1.52-.08-.14-.3-.22-.62-.38Z" />
    </svg>
  );
}
